<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>高清校园电视台</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>高清校园电视台</h2>
          <p>
            “数字化校园电视台”是由数字化摄录(包括演播室声学装 修)、采集、编辑、播出系统等组成，是供学校自行拍摄、制 做各种电视节目录像，如领导讲话、优秀示范课、教师访 谈录、文艺节目、运动会、实验活动等，并具有现场直播、录 播、转播、转录等多种功能。系统内设置摄像机、编辑机、非 线编、直播机等系统设备。根据不同的条件、不同的需求，实
            现学校的多媒体教学应用等多种功能。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>先进性</h2>
          <p>在投资费用许可的情况下，系统采用当今先进的技术和设备，一方 面能反映系统所具有的先进水平，另一方面又使系统具有强大的 发展潜力，以便该系统在尽可能的时间内与社会发展相适应。</p>
        </li>
        <li>
          <h2>可靠性</h2>
          <p>系统设计时在成本接受的条件下，从系统结构、设备选择、产品供应 商的技术服务及维修响应能力等各方面均严格要求，使得故障发生的 可能性尽可能少，即便是出现故障时，影响面也要尽可能小。</p>
        </li>
        <li>
          <h2>可扩充性</h2>
          <p>系统设计时应充分考虑今后的发展需要，系统应具有预备容量的扩充与升 级换代的可能。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SshdcampusTV',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
